import { programmeQuery } from "@common/api/maintenance-programme"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DetailPane } from "@/components/layout/detail-panel"
import useCustomToast from "@/hooks/use-custom-toast"
import { EnrolForm } from "../-components/enrol-form/enrol-form"
import { PaneHeading } from "../-components/pane-heading"

export const Route = createFileRoute(
  "/_layout/maintenance-programmes_/$programmeId/aircraft/enrol",
)({
  component: EnrolPane,
})

function EnrolPane(): React.ReactElement {
  const { programmeId } = Route.useParams()
  const { data: programme } = useSuspenseQuery(
    programmeQuery({ programme_id: programmeId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/maintenance-programmes/$programmeId",
      params: { programmeId },
      search: true,
    })

  return (
    <DetailPane
      title="Enroll aircraft"
      heading={<PaneHeading title="Enroll aircraft" />}
      onClose={close}
    >
      <EnrolForm
        programmeId={programmeId}
        onEnrol={() => {
          showToast("Aircraft enrolled", programme.number, "success")
          close()
        }}
        onCancel={close}
      />
    </DetailPane>
  )
}
